import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming'
import { ThemeProvider as FabricThemeProvider } from 'office-ui-fabric-react/lib/Foundation'
import * as React from 'react'
import { Theme } from './Theme'
import { ThemeContext } from './ThemeContext'
import * as themes from './themes'

export const ThemeProvider: React.FunctionComponent<{ theme?: Theme }> = ({
  theme: maybeTheme,
  children,
}) => {
  const theme = maybeTheme || themes.default
  return (
    <ThemeContext.Provider value={theme}>
      <EmotionThemeProvider theme={theme}>
        <FabricThemeProvider theme={theme}>{children}</FabricThemeProvider>
      </EmotionThemeProvider>
    </ThemeContext.Provider>
  )
}
